import { reducer as formReducer } from 'redux-form';

/**
 * Modules Reducers.
 */
import admin from 'modules/admin/reducers';
import affiliation from 'modules/affiliation/reducers/affiliation.reducer';
import improvements from 'modules/affiliation/reducers/improvements.reducer';

/**
 * Persisted reducers config
 */

export default {
  form: formReducer,
  admin,
  affiliation,
  improvements,
};
